import shopifyImg from '@assets/shopify_icon.png';
import shoplazzaImg from '@assets/shoplazza.png';
import gentlyImg from '@assets/gently_logo.svg';
import treetImg from '@assets/treet_logo.svg';
import garmentoryImg from '@assets/garmentory_logo.svg';
import sidelineSwapImg from '@assets/sidelineSwap_logo.svg';
import dhgateImg from '@assets/dhgate_logo.svg';
import curtsyImg from '@assets/curtsy_logo.svg';
import mxlockerImg from '@assets/mxlocker_logo.svg';
import SPOImg from '@assets/spo_logo.svg';
import GWFImg from '@assets/gwf_logo.svg';
import SSImg from '@assets/shopshops_logo.svg';

export const ICON_MAP = {
  Shopify: shopifyImg,
  Shoplazza: shoplazzaImg,
  Gently: gentlyImg,
  Treet: treetImg,
  Garmentory: garmentoryImg,
  sidelineswap: sidelineSwapImg,
  Dhgate: dhgateImg,
  Curtsy: curtsyImg,
  MXLocker: mxlockerImg,
  Gwf: GWFImg,
  Spo: SPOImg,
  Shopshops: SSImg,
};
